module.exports = __webpack_public_path__ + "static/asiamiles-27f913397325dd21d8c53ef686b890b0.png";